// @flow
import React, { PureComponent } from 'react';
import SocialCard from 'components/social/SocialCard';
import type { SocialContent } from 'types/SocialContent';
import { 
  FacebookProvider,
  InstagramProvider,
  TwitterProvider,
  YoutubeProvider,
  AllProvider
} from 'constants/socialConstants';
import ButtonIcon from 'components/fragments/button/ButtonIcon';
import { getValidSocialCards } from 'utils/socialUtils';
import type { liensRsType } from 'types/Settings';

type Props = {
  socialCards: SocialContent[],
  showCards: boolean,
  liensRs: liensRsType
};

type State = {
  provider: string,
  page: number,
  compteRS: number,
};

class SocialCardNavigator extends PureComponent<Props, State> {
  state: State = {
    provider: AllProvider,
    page: 0,
    compteRS: 0,
  };

  componentDidMount() {
    const hasfbposts = getValidSocialCards(this.props.socialCards, FacebookProvider).length > 0;
    const hastwposts = getValidSocialCards(this.props.socialCards, TwitterProvider).length > 0;
    const hasinstaposts = getValidSocialCards(this.props.socialCards, InstagramProvider).length > 0;
    const hasyoutubeposts = getValidSocialCards(this.props.socialCards, YoutubeProvider).length > 0;

    let compteRS = 0;
    if (hasfbposts) {
      compteRS++;
    }
    if (hastwposts) {
      compteRS++;
    }
    if (hasinstaposts) {
      compteRS++;
    }
    if (hasyoutubeposts) {
      compteRS++;
    }
    if (compteRS === 1) {
      if (hasfbposts) {
        this.setState({provider: FacebookProvider});
      } else if (hastwposts) {
        this.setState({provider: TwitterProvider});
      } else if (hasinstaposts) {
        this.setState({provider: InstagramProvider});
      } else if (hasyoutubeposts) {
        this.setState({provider: YoutubeProvider});
      }
    }
    this.setState({compteRS: compteRS});
  }

  componentDidUpdate() {
    const hasfbposts = getValidSocialCards(this.props.socialCards, FacebookProvider).length > 0;
    const hastwposts = getValidSocialCards(this.props.socialCards, TwitterProvider).length > 0;
    const hasinstaposts = getValidSocialCards(this.props.socialCards, InstagramProvider).length > 0;
    const hasyoutubeposts = getValidSocialCards(this.props.socialCards, YoutubeProvider).length > 0;
    let compteRS = 0;
    if (hasfbposts) {
      compteRS++;
    }
    if (hastwposts) {
      compteRS++;
    }
    if (hasinstaposts) {
      compteRS++;
    }
    if (hasyoutubeposts) {
      compteRS++;
    }
    if (compteRS === 1) {
      if (hasfbposts) {
        this.setState({provider: FacebookProvider});
      } else if (hastwposts) {
        this.setState({provider: TwitterProvider});
      } else if (hasinstaposts) {
        this.setState({provider: InstagramProvider});
      } else if (hasyoutubeposts) {
        this.setState({provider: YoutubeProvider});
      }
    }
    this.setState({compteRS: compteRS});
  }


  renderCards = (socialCards: SocialContent[]): Array<?React$Element<*>> => {
    return socialCards.map((c: SocialContent, index: number) => {
      if (c.type === FacebookProvider && c.description === '') {
        return null;
      }
      return <SocialCard key={c.id} content={c} transparent={index === 3} />;
    });
  };

  onClicked = (provider: string) => (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ provider, page: 0 });
  };

  setPage = (page: number) => (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ page });
  };

  render() {
    const {
      liensRs: {
        fb_lien,
        twitter_lien,
        instagram_lien,
        youtube_lien,
      },
      socialCards,
      showCards,
    } = this.props;
    const { provider, compteRS, page } = this.state;

    const validSocialCards = getValidSocialCards(socialCards, provider);
    const hasposts = socialCards.length > 0;
    const hasfbposts = getValidSocialCards(socialCards, FacebookProvider).length > 0;
    const hastwposts = getValidSocialCards(socialCards, TwitterProvider).length > 0;
    const hasinstaposts = getValidSocialCards(socialCards, InstagramProvider).length > 0;
    const hasyoutubeposts = getValidSocialCards(this.props.socialCards, YoutubeProvider).length > 0;
    const displayedSocialCards = validSocialCards.slice(page * 3, 4 + page * 3);
    const maxPage = Math.max(Math.ceil(validSocialCards.length / 3) - 1, 0);

    return (
      <div className="col col-md-8 col-lg-9">
        <div className="live-feed__tag mb-2">
          {hasposts && compteRS > 1 && (
            <a // eslint-disable-line
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === AllProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(AllProvider)}
            >
              Tous
            </a>
          )}
          {hasfbposts && fb_lien !== '' && (
            <a // eslint-disable-line
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === FacebookProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(FacebookProvider)}
            >
              Facebook
            </a>
          )}
          {hastwposts && twitter_lien !== '' && (
            <a // eslint-disable-line
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === TwitterProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(TwitterProvider)}
            >
              Twitter
            </a>
          )}
          {hasinstaposts && instagram_lien !== '' && (
            <a // eslint-disable-line
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === InstagramProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(InstagramProvider)}
            >
              Instagram
            </a>
          )}
          {hasyoutubeposts && youtube_lien !== '' && (
            <a // eslint-disable-line
              role="button"
              tabIndex={0}
              className={`tag tag--blue${provider === YoutubeProvider ? ' is-active' : ''}`}
              onClick={this.onClicked(YoutubeProvider)}
            >
              Youtube
            </a>
          )}
        </div>
        <div className="carousel">
          {hasposts && (
            <div className="carousel__nav">
              <ButtonIcon
                label={null}
                url={null}
                isDark
                icon="icon-arrow-left"
                isDisabled={page === 0 || !showCards}
                onClick={this.setPage(page - 1)}
                titleSEO="Précédent"
              />
              <ButtonIcon
                label={null}
                url={null}
                isDark
                icon="icon-arrow-right"
                isDisabled={page === maxPage || !showCards}
                onClick={this.setPage(page + 1)}
                titleSEO="Suivant"
              />
            </div>
          )}
          <div className="carousel__wrapper">
            {showCards && this.renderCards(displayedSocialCards)}
          </div>
        </div>
      </div>
    );
  }
}

export default SocialCardNavigator;
